<script setup>
import { computed } from 'vue';

import MetricCard from '../overview/MetricCard.vue';
import { useVoiceCallMetrics } from '../../composables/useVoiceCallMetrics';

const { metrics, isLoading } = useVoiceCallMetrics('stats', {
  includePresence: true,
});
const categories = computed(() => metrics.value.categories || {});
const agentStatus = computed(() => metrics.value.agent_status || {});

const categoryMetrics = [
  ['ACTIVE', 'active'],
  ['QUEUED', 'queued'],
];

const statusMetrics = [
  ['IN_CALL', 'in_call'],
  ['AVAILABLE', 'available'],
  ['BUSY', 'busy'],
];
</script>

<template>
  <div class="flex flex-col items-stretch gap-4 md:flex-row">
    <div class="w-full md:w-1/2">
      <MetricCard
        :header="$t('VOICE_CALL_DASHBOARD.CATEGORIES.HEADER')"
        :is-loading="isLoading"
        :loading-message="$t('VOICE_CALL_DASHBOARD.LOADING')"
      >
        <div
          v-for="[label, key] in categoryMetrics"
          :key="key"
          class="flex min-w-0 flex-1 flex-col items-center pb-2 text-center"
        >
          <h3
            class="flex h-12 items-end justify-center break-words text-xs leading-5 text-n-slate-11"
          >
            {{ $t(`VOICE_CALL_DASHBOARD.CATEGORIES.${label}`) }}
          </h3>
          <p class="mb-0 mt-1 text-2xl text-n-slate-12">
            {{ categories[key] || 0 }}
          </p>
        </div>
      </MetricCard>
    </div>
    <div class="w-full md:w-1/2">
      <MetricCard
        :header="$t('VOICE_CALL_DASHBOARD.AGENT_STATUS.HEADER')"
        :is-loading="isLoading"
        :loading-message="$t('VOICE_CALL_DASHBOARD.LOADING')"
      >
        <div
          v-for="[label, key] in statusMetrics"
          :key="key"
          class="flex min-w-0 flex-1 flex-col items-center pb-2 text-center"
        >
          <h3
            class="flex h-12 items-end justify-center break-words text-xs leading-5 text-n-slate-11"
          >
            {{ $t(`VOICE_CALL_DASHBOARD.AGENT_STATUS.${label}`) }}
          </h3>
          <p class="mb-0 mt-1 text-2xl text-n-slate-12">
            {{ agentStatus[key] || 0 }}
          </p>
        </div>
      </MetricCard>
    </div>
  </div>
</template>
